import { useEffect } from 'react';
import { triggerOptimizelyActivation } from './trigger-optimizely-activation';

export function useTriggerOptimizelyActivation(optimizelyId: string) {
    useEffect(() => {
        triggerOptimizelyActivation(optimizelyId);
    }, [optimizelyId]);
}
